import {Button, Grid, Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import clsx from 'clsx'
import React, {useState} from 'react'

import {AdvertBadge} from '../advert-badge'
import {AdvertInfo} from '../advert-info'
import type {PromotionBanner} from '../AutoBanner.types'
import {AutoBannerImage} from '../AutoBannerImage'
import * as classes from './AutoBannerSlide.classes'

export const AutoBannerSlide: React.FC<PromotionBanner> = ({
  link,
  title,
  subtitle,
  backgroundColor,
  trailImageTag,
  advertisementText,
  advertisementInfo,
}) => {
  const [isAdvertInfoOpened, setIsAdvertInfoOpened] = useState(false)
  const t = useI18n()

  return (
    <a
      className={clsx(classes.root, advertisementInfo && classes.withAdvert, trailImageTag && classes.withTrailImage)}
      href={link}
      style={{backgroundColor}}
    >
      <Grid alignItems="center" size="m" wrap="nowrap" container>
        <Grid item xs>
          <Typography group="tight" thickness="medium" variant="body2">
            {title}
          </Typography>
          {subtitle && (
            <Typography group="tight" variant="caption1">
              {subtitle}
            </Typography>
          )}
        </Grid>
      </Grid>

      {advertisementInfo && (
        <>
          <div
            className={classes.advertBadge}
            onClick={e => {
              e.preventDefault()
              setIsAdvertInfoOpened(true)
            }}
          >
            <AdvertBadge text={advertisementText} />
          </div>
          <AdvertInfo
            content={advertisementInfo}
            isOpened={isAdvertInfoOpened}
            onClose={() => {
              setIsAdvertInfoOpened(false)
            }}
          />
        </>
      )}
      {trailImageTag ? (
        <div className={classes.trailImage}>
          <AutoBannerImage tag={trailImageTag} />
        </div>
      ) : (
        <Button className={classes.button} shape="circle" size="xs" variant="outline">
          <Typography group="tight" thickness="medium" variant="caption1">
            {t('route.to_know', 'Узнать')}
          </Typography>
        </Button>
      )}
    </a>
  )
}
